import React, { useState } from 'react'
import { Button, Modal } from 'antd';
import { formatSchoolName } from '../../utilities/formatSchoolName';

const ProfileModal = ({ row }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => setIsModalOpen(true);
    const handleCancel = () => setIsModalOpen(false);


    return (
        <>
            <Button type="primary" onClick={showModal}>
                View Profile
            </Button>
            <Modal
                title={row.name}
                open={isModalOpen}
                onCancel={handleCancel}
                footer={
                    <Button type="primary" onClick={handleCancel}>
                        Cancel
                    </Button>
                }
            >
                <p><strong>Email:</strong> {row?.email}</p>
                <p><strong>Department:</strong> {row?.department}</p>
                <p><strong>Designation:</strong> {row?.designation}</p>
                <p><strong>School:</strong> {formatSchoolName(row?.school)}</p>
            </Modal>
        </>
    )
}

export default ProfileModal
